class Referrer {
    constructor() {
        var _a, _b;
        this.session = (_a = this.getFromSession()) !== null && _a !== void 0 ? _a : document.referrer;
        sessionStorage.setItem(Referrer.storageId, this.session);
        this.local = (_b = this.getFromLocal()) !== null && _b !== void 0 ? _b : document.referrer;
        localStorage.setItem(Referrer.storageId, this.local);
    }
    getFromLocal() {
        const value = localStorage.getItem(Referrer.storageId);
        if (value && value.length > 0) {
            return value;
        }
    }
    getFromSession() {
        const value = sessionStorage.getItem(Referrer.storageId);
        if (value && value.length > 0) {
            return value;
        }
    }
    toJson() {
        if ((this.local && this.local.length > 0) || (this.session && this.session.length > 0)) {
            return {
                local: this.local,
                session: this.session,
            };
        }
    }
}
Referrer.storageId = '_coin_referrer';
export default Referrer;
//# sourceMappingURL=Referrer.js.map